import axios from 'axios';
import { baseURLWithoutVersion } from '../config/setting';

const RESERVED_SLUGS = ['cert-login', 'login'];

export const CommonService = {
  getCustomPropertise(associationName, context) {
    const slug = String(associationName || '').toLowerCase();
    if (RESERVED_SLUGS.includes(slug)) return Promise.resolve({ data: null });

    const url = `${baseURLWithoutVersion}custom/${slug ? `${encodeURIComponent(slug)}/` : ''}`;
    const headers = {};
    const params = {};
    if (context && context.token && context.requestId) {
      headers.Authorization = `Token ${context.token}`;
      params.requestId = context.requestId;
      if (context.authId) params.authId = context.authId;
    }
    return axios.get(url, { headers, params });
  },
};
